<template>

  <v-app id="inspire">
    
    <v-snackbar right bottom multi-line :color="$store.state.alert.color" v-model="$store.state.alert.visible">
      {{ $store.state.alert.message }}
      <v-btn x-small fab depressed @click="$store.state.alert.visible = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!--v-overlay v-if="$store.state.loader" z-index="1000">
      <v-progress-circular
      indeterminate
      color="white"
    ></v-progress-circular>
    </v-overlay-->


<!--v-dialog v-model="$store.state.loader" persistent width="300">
      <v-card
        color="primary"
        elevation="0" class="pa-3">
        
          <v-progress-linear
            indeterminate
            color="white"
          ></v-progress-linear>
        
      </v-card>
    </v-dialog-->

    <v-navigation-drawer color="sidebar" v-model="drawer" app v-if="isLoggedIn">
      <v-list dense>

        <v-list-item two-line>
            <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn small depressed fab class="mr-1" to="/" v-on="on"><v-icon>mdi-home</v-icon></v-btn>
            </template>
            <span>Home</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn small depressed fab @click="logout()" v-if="isLoggedIn" v-on="on"><v-icon>mdi-logout-variant</v-icon></v-btn>
            </template>
            <span>Sair</span>
          </v-tooltip>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link v-for="menu in menus.cadastros" v-bind:key="menu.label" :to="menu.route">
          <v-list-item-content>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link v-for="menu in menus.movimentos" v-bind:key="menu.label" :to="menu.route">
          <v-list-item-content>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link v-for="menu in menus.administracao" v-bind:key="menu.label" :to="menu.route">
          <v-list-item-content>
            <v-list-item-title>{{ menu.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

      
      </v-list>
        
    </v-navigation-drawer>

    <v-app-bar app color="topbar" v-if="isLoggedIn">
      <v-app-bar-nav-icon class="white--text" @click.stop="drawer = !drawer" v-if="isLoggedIn"/>
        <v-img :src="require('./assets/pdv-manager.svg')" contain height="27" />
    </v-app-bar>

    <v-main>
      <v-progress-linear 
      :indeterminate="$store.state.loader"
      color="primary"
    ></v-progress-linear>
      <router-view></router-view>
    </v-main>

    <v-footer app class="d-flex justify-space-between">
      <v-switch class="ma-1 pa-0"
        v-model="$vuetify.theme.dark"
        hide-details
        inset
      ></v-switch>
    </v-footer>

  </v-app>
</template>



<script>
export default {
  data: (vm) => ({

    initialDark: vm.$vuetify ? vm.$vuetify.theme.dark : false,

    drawer: null,
    menus: {
        administracao: [
          {
            label: 'Usuários',
            route: '/usuario'
          }
        ],
        cadastros: [
          {
            label: 'Empresas',
            route: '/filial'
          },
          {
            label: 'Pontos de Vendas',
            route: '/pontodevenda'
          },
          {
            label: 'Empregados',
            route: '/empregado'
          },
          {
            label: 'Finalizadoras',
            route: '/finalizadora'
          },
          {
            label: 'Parametros',
            route: '/parametro'
          },
          {
            label: 'Recursos Externos',
            route: '/recurso'
          },
          {
            label: 'Produtos',
            route: '/produto'
          },
          {
            label: 'Pedidos',
            route: '/pedido'
          },
          {
            label: 'Movimentos Financeiros',
            route: '/movimentofinanceiro'
          },
        ],
        movimentos: [
          {
            label: 'NFC-e',
            route: '/nfce'
          },
          {
            label: 'CF-e',
            route: '/cfe'
          },
          {
            label: 'Outros Documentos',
            route: '/naofiscal'
          }
        ]
      }
  }),
  computed : {
    isLoggedIn : function(){ 
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout').then(() => { this.$router.push('/login') })
    },
    navigateTo(where){
      this.$router.push({name: where})
    }
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) { 
      // eslint-disable-next-line no-unused-vars
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
        }
        throw err;
      });
    });
  }

}//ECEFF1
</script>

<style lang="sass">
  .v-btn
    font-size: '40'
    color: 'red'
</style>

<!--style scoped>
/*
  .theme--light.v-application {
    background-color: #E8F5E9;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: white !important 
  }*/
</style-->